import { Outlet } from 'react-router-dom';
import { Box, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Toolbar } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PersonIcon from '@mui/icons-material/Person';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import RuleIcon from '@mui/icons-material/Rule';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { TopAppBar } from './TopAppBar';

const drawerWidth = 240;

const clinicianNavItems = [
  { label: 'Dashboard', path: '/nutritionist/dashboard', icon: <DashboardIcon /> },
  { label: 'Patients', path: '/nutritionist/patients', icon: <PersonIcon /> },
  { label: 'Patient CGM Device Data Import', path: '/nutritionist/cgm-import', icon: <UploadFileIcon /> },
  { label: 'Patient Protocol Builder', path: '/nutritionist/protocol-builder', icon: <RuleIcon /> },
  { label: 'Patient Data Gap Analysis', path: '/nutritionist/questions-gaps', icon: <HelpOutlineIcon /> },
  { label: 'Knowledge Base', path: '/nutritionist/adherence', icon: <MenuBookIcon /> },
];

/**
 * Clinician Portal Layout
 * Used for all nutritionist-facing screens (N0-N6)
 */
export const ClinicianPortalLayout = () => {
  return (
    <Box sx={{ display: 'flex' }}>
      <TopAppBar />
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
          },
        }}
      >
        <Toolbar />
        <Box sx={{ overflow: 'auto' }}>
          <List>
            {clinicianNavItems.map((item) => (
              <ListItem key={item.path} disablePadding>
                <ListItemButton component={RouterLink} to={item.path}>
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.label} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Toolbar />
        <Outlet />
      </Box>
    </Box>
  );
};
